import { format } from "date-fns";
import { omit } from "lodash";

import type { SurveyAnswers } from "@/contexts";
import { omitCmsAccessPhi } from "@/utils/cmsAccess";

export const DPP_SURVEY_ANSWER_BLOCKLIST = [
  "createAccount",
  "createPassword",
  "completeProfile",
  "existingPassword",
  "phoneNumber",
];

export const sanitizeDppSurveyAnswers = (
  rawSurveyAnswers: SurveyAnswers,
): Record<string, any> => {
  const surveyAnswers = omitCmsAccessPhi(rawSurveyAnswers);
  let sanitizedSurveyAnswers: Record<string, any> = omit(
    surveyAnswers,
    DPP_SURVEY_ANSWER_BLOCKLIST,
  );

  // convert date to string (don't need/want time info)
  if (surveyAnswers.eligibilityCheck?.dob) {
    sanitizedSurveyAnswers = {
      ...sanitizedSurveyAnswers,
      eligibilityCheck: {
        ...surveyAnswers.eligibilityCheck,
        dob: format(surveyAnswers.eligibilityCheck.dob as Date, "yyyy-MM-dd"),
      },
    };
  }
  return sanitizedSurveyAnswers;
};
